class ArnNewsletterHpStrip extends HTMLElement {
    constructor() {
        super();
        // Bind the close handler to maintain 'this' context
        this.handleClose = this.handleClose.bind(this);
    }

    connectedCallback() {

        // Read the acceptsMarketing attribute from the dataset
        this.acceptsMarketing = this.dataset.acceptsMarketing === 'true';

        // Check if the strip should be hidden based on sessionStorage
        this.checkVisibilityState();

        // Add event listener to the close button
        this.setupCloseButton();
    }

    disconnectedCallback() {
        // Clean up event listener when component is removed
        const closeBtn = this.querySelector('#arn-newsletter-hp-strip-close-btn');
        if (closeBtn) {
            closeBtn.removeEventListener('click', this.handleClose);
        }
    }

    /**
     * Check sessionStorage to determine if strip should be visible
     * If 'sessionStorage' has 'arn-newsletter-strip-closed' set to 'true', hide the strip
     * Also checks sessionStorage for subscription status
     */
    checkVisibilityState() {
        const stripClosed = sessionStorage.getItem('arn-newsletter-strip-closed') === 'true';
        const newsletterSubscribed = sessionStorage.getItem('arn-newsletter-subscribed') === 'true';

        // If either condition is met, hide the strip
        if (this.acceptsMarketing || newsletterSubscribed || stripClosed) {
            this.hideStrip();
        }
        else {
            // Show the strip if not previously closed or subscribed
            this.style.removeProperty('display');
        }
    }

    /**
     * Set up the close button event listener
     */
    setupCloseButton() {
        const closeBtn = this.querySelector('#arn-newsletter-hp-strip-close-btn');

        if (closeBtn) {
            closeBtn.addEventListener('click', this.handleClose);
        }
    }

    /**
     * Handle close button click
     * Save state to sessionStorage and hide the strip
     */
    handleClose() {
        // Save the preference to sessionStorage
        sessionStorage.setItem('arn-newsletter-strip-closed', 'true');

        // Hide the strip with a smooth transition
        this.hideStrip();
    }

    /**
     * Hide the newsletter strip from view
     */
    hideStrip() {
        this.style.display = 'none';
    }
}

// Register the custom element
customElements.define('arn-newsletter-hp-strip', ArnNewsletterHpStrip);